/**
 * Hero gallery (.tx-sp__gal[data-tx-gal]) — an index column over the
 * product's views: the 3D model takes slot 01 when the product has one,
 * then the photos and the certification images, which cross-fade inside
 * the shared plate. Everything
 * is server-rendered, so without JS the first view simply stays put.
 */
const initGallery = (root) => {
    const rows = Array.from(root.querySelectorAll('[data-tx-gal-row]'));
    const imgs = Array.from(root.querySelectorAll('.tx-sp__gal-img'));
    if (rows.length < 2 || imgs.length === 0) return;

    const modelLayer = root.querySelector('[data-tx-gal-model]');
    const plateLayer = root.querySelector('[data-tx-gal-plate]');
    const nameOut = root.querySelector('[data-tx-gal-name-out]');
    const capOut  = root.querySelector('[data-tx-gal-cap-out]');
    const fnum    = root.querySelector('[data-tx-gal-fnum]');
    const count   = root.querySelector('[data-tx-gal-count]');

    let current = Math.max(0, rows.findIndex((r) => r.classList.contains('is-active')));

    const show = (idx) => {
        const i = (idx + rows.length) % rows.length;
        if (i === current) return;

        const row = rows[i];
        const isModel = row.dataset.txGalKind === 'model';

        if (modelLayer) modelLayer.classList.toggle('is-active', isModel);
        if (plateLayer) plateLayer.classList.toggle('is-active', !isModel);

        // The plate's own labels only ever describe a photo — leave them
        // untouched while the model layer is up.
        if (!isModel) {
            const k = parseInt(row.dataset.txGalImg || '0', 10);
            imgs.forEach((im, j) => {
                im.classList.toggle('is-active', j === k);
                // The hidden plates stay in the DOM, so they have to leave
                // the accessibility tree or every photo is announced.
                if (j === k) im.removeAttribute('aria-hidden');
                else im.setAttribute('aria-hidden', 'true');
            });
            if (nameOut) nameOut.textContent = row.dataset.txGalName || '';
            if (capOut)  capOut.textContent  = row.dataset.txGalCap || '';
            if (fnum)    fnum.textContent    = row.dataset.txGalBadge || '';
        }

        rows.forEach((r, j) => {
            r.classList.toggle('is-active', j === i);
            r.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        });

        if (count) count.textContent = row.dataset.txGalN || String(i + 1).padStart(2, '0');
        current = i;
    };

    rows.forEach((r, i) => r.addEventListener('click', () => show(i)));

    const prev = root.querySelector('[data-tx-gal-prev]');
    const next = root.querySelector('[data-tx-gal-next]');
    if (prev) prev.addEventListener('click', () => show(current - 1));
    if (next) next.addEventListener('click', () => show(current + 1));

    // Arrows work whenever focus is inside the gallery (the row buttons and
    // steppers are all focusable, so the event reaches this root). Stepping
    // from a row keeps focus on the row that is now selected; stepping from
    // inside a view (the 3D model's button) moves it there too, since that
    // view is about to hide.
    root.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const from = document.activeElement;
        show(e.key === 'ArrowRight' ? current + 1 : current - 1);
        if (from && (from.hasAttribute('data-tx-gal-row') || from.closest('[data-tx-gal-model], [data-tx-gal-plate]'))) {
            rows[current].focus();
        }
    });
};

const init = () => {
    document.querySelectorAll('[data-tx-gal]').forEach(initGallery);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
